module.exports = __webpack_public_path__ + "images/dec7e035baf76cef7e9bf7662f587342-StPete.png";